/**
 * Created by zhangsanfeng on 2019/11/19.
 */

import {Message} from 'element-ui';

export const tool = {
  createComparisonFunction(propertyName){
    return function (object1, object2) {
      var value1 = object1[propertyName];
      var value2 = object2[propertyName];

      if (value1 < value2) {
        return -1;
      } else if (value1 > value2) {
        return 1;
      } else {
        return 0;
      }
    };
  },

  getExtent(p1x, p1y, p2x, p2y) {
    let dx = p1x === p2x ? 2 : Math.abs(p2x - p1x);
    let dy = p1y === p2y ? 3 : Math.abs(p2y - p1y);
    let r = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    //console.log(p1x, p1y, p2x, p2y, r);
    return !!r ? r : 1;
  },

  mathRandom: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  //success warning error
  message(text, type, callback) {
    Message({
      message: text,
      type: type,
      duration: 1000,
      onClose: () => {
        callback && callback();
      }
    })
  },

  setCookie: function (name, value, iDay, iPath) {
    let oDate = new Date();
    iDay = arguments[2] ? arguments[2] : 7;
    iPath = arguments[3] ? arguments[3] : "/";
    oDate.setDate(oDate.getDate() + iDay);
    document.cookie = name + "=" + encodeURI(value) + ";expires=" + oDate + ";path=" + iPath;
  },

  getCookie: function (name) {
    let arr = document.cookie.split("; ");
    for (let i = 0; i < arr.length; i++) {
      let arr2 = arr[i].split("=");
      if (arr2[0] === name) {
        return decodeURI(arr2[1]);
      }
    }
    return "";
  },

  tree(oldArr, pid, id) {
    oldArr.forEach(element => {
      let parentId = element[pid];
      if (parentId !== 0) {
        oldArr.forEach(ele => {
          if (ele[id] == parentId) {
            if (!ele.son) {
              ele.son = [];
            }
            ele.son.push(element);
          }
        });
      }
    });
    oldArr = oldArr.filter(ele => ele[pid] === 0);
    return oldArr;
  },

  formatDateTime(a) {
    let t = new Date(a);
    let oYear = t.getFullYear(), oMonth = t.getMonth() + 1, oDate = t.getDate(), oHours = t.getHours(),
        oMinutes = t.getMinutes(), oSeconds = t.getSeconds();
    return (oYear + "-" + this.ddigit(oMonth) + "-" + this.ddigit(oDate) + ' ' + this.ddigit(oHours) + ":" + this.ddigit(oMinutes) + ":" + this.ddigit(oSeconds));
  },

  ddigit: function (a) {
    return a < 10 ? '0' + a : a;
  },
};
